<template>
    <NuxtRouteAnnouncer />
    <LazyCommonLoader v-show="!loadComplete" />
    <CommonHeader />
    <div class="h-screen">
        <NuxtLayout>
            <div v-if="status == 'success'" class="elle-page-default">
                <CommonBuilder :data="dataSettings?.elements ?? []" />
            </div>
        </NuxtLayout>
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const nuxtApp = useNuxtApp();
const menuData = useMenusData();
const { t } = useI18n();
const settingsData = useSettingsData();
const categoriesData = useCategoriesData();
const loadComplete = useGlobalLoaded();
const pageComplete = usePageComplete();
const pageBeforeComplete = usePageBeforeComplete();
const toggleMobileMenu = useToggleMobileMenu();
const isDesktop = useMediaQuery('(min-width: 1181px)');

nuxtApp.hook('app:suspense:resolve', () => {
    setTimeout(() => nuxtApp.$ScrollTrigger.refresh(true), 100);
});

useSeoData({
    title: t('site.title_not_fonud'),
    description: t('site.description_not_found'),
    keywords: [],
    social: null,
    advanced: null
});

const siteId = useAvailableCraftLocales();

const [settingsResult, menusResult] = await Promise.all([
    useAsyncGql({
        operation: 'settings',
        variables: { siteId }
    }),
    useAsyncGql({
        operation: 'menus',
        variables: { siteId }
    })
]);

const { data: settings, status } = settingsResult;
const { data: menus } = menusResult;

const dataSettings = computed<CmsItem | null>(() => {
    const items = (settings.value?.settings as CmsItem[]) ?? [];
    return items.find(item => item.siteId == useSiteId()) ?? null;
});

// menus
menuData.value.menu_header = (menus.value?.mainmenuheader as CmsItem[]) ?? [];
menuData.value.menu_footer = (menus.value?.footermenu as CmsItem[]) ?? [];
menuData.value.menu_footer_information = (menus.value?.footerinformation as CmsItem[]) ?? [];

// settings
settingsData.value = (settings.value?.settings as CmsItem[]) ?? [];
categoriesData.value.news = (settings.value?.news as CmsItem[]) ?? [];
categoriesData.value.team = (settings.value?.team as CmsItem[]) ?? [];
categoriesData.value.folder = (settings.value?.folder as CmsItem[]) ?? [];
categoriesData.value.faq = (settings.value?.faq as CmsItem[]) ?? [];

watch(
    () => pageComplete.value,
    state => {
        nextTick(() => {
            useLenis(state);
            useHeader(state);
            useDataSpeed();
        });
    }
);

watch(
    () => isDesktop.value,
    state => {
        nextTick(() => nuxtApp.$ScrollTrigger.refresh());
        if (state) {
            nextTick(() => {
                toggleMobileMenu.value = false;
            });
        }
    }
);

onMounted(() => {
    nextTick(() => {
        pageBeforeComplete.value = true;
        pageComplete.value = true;
        loadComplete.value = true;
        document.querySelector('.lenis-content')?.classList.remove('is-global-loading');
    });
});

onUnmounted(() => {
    clearError({});
});
</script>
